module.exports = __webpack_public_path__ + "media/images/inperson-9c2a2b2473c0b16e0eb7092c95014dc5122c7300ebea7583170e5be562da9b68.png";